import styled from 'styled-components';

export const ModalContainer = styled.div`
  width: 470px;
  padding: 50px 30px 0;
`;

export const EmojiTile = styled.a`
  display: flex;
  flex-flow: column;
  align-items: center;
  text-align: center;
  width: 74px;
  height: 74px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.hoverBrand};
  padding-top: 13px;
  padding-bottom: 8px;
  justify-content: space-between;
  cursor: pointer;
  transition: box-shadow 0.3s ease;
  text-decoration: none !important;
  margin-bottom: 50px;

  &:hover {
    box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.primary};
  }
`;
